'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserFavorites = exports.fetchUserEntitlements = exports.fetchUserSettings = exports.fetchUserDetails = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _baseFetch = require('./baseFetch');

var _baseFetch2 = _interopRequireDefault(_baseFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchUserDetails = exports.fetchUserDetails = function fetchUserDetails(baseUrl, cookie) {
  return (0, _baseFetch2.default)(baseUrl + '/user?', undefined, cookie);
};

var fetchUserSettings = exports.fetchUserSettings = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(baseUrl, clientIp) {
    var options;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {};

            if (clientIp) options.headers = new Headers({ 'x-client-ip': clientIp });
            return _context.abrupt('return', (0, _baseFetch2.default)(baseUrl + '/user/settings?', options));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchUserSettings(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchUserEntitlements = exports.fetchUserEntitlements = function fetchUserEntitlements(baseUrl) {
  return (0, _baseFetch2.default)(baseUrl + '/entitlements?');
};

var fetchUserFavorites = exports.fetchUserFavorites = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(baseUrl, clientIp) {
    var options;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = {};

            if (clientIp) options.headers = new Headers({ 'x-client-ip': clientIp });
            return _context2.abrupt('return', (0, _baseFetch2.default)(baseUrl + '/kbyg/favorites?', options));

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function fetchUserFavorites(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/utils/api/user.js
// module id = 725
// module chunks = 11